import { inject } from 'vue'

/**
 * The shared state of the Audience tab, provided by the shell view
 * (`StreamsManageAudience.vue`) and injected by its route children.
 *
 * The room socket, the stats poll and the captures count live in the shell so
 * they survive sub-tab navigation: if they lived in the Live room pane, every
 * trip to Panel setup would drop the socket, kill presence and the badges,
 * and force a rejoin on the way back. Children take the refs they need and
 * keep their own pane-local state (modals, drafts, active pane) to
 * themselves.
 */
export const AUDIENCE_CONSOLE = Symbol('audience-console')

export function useAudienceConsole() {
	return inject(AUDIENCE_CONSOLE)
}

/** The toggleable panel features, shared by the shell and Panel setup. */
export const FEATURES = [
	{ key: 'chat', label: 'Live chat', hint: 'Viewers can post messages during the stream.' },
	{ key: 'qa', label: 'Q&A', hint: 'Viewers submit questions and upvote each other\'s.' },
	{ key: 'polls', label: 'Polls', hint: 'You run polls from here and viewers vote in the player.' },
	{ key: 'reactions', label: 'Reactions', hint: 'Floating emoji reactions, aggregated so they stay cheap.' }
]
